/**
 * Mantine theme — tenant brand_color dinamik.
 */
import { type MantineColorsTuple, createTheme } from "@mantine/core";

// Default brand: tenant'tan gelmiyorsa
const DEFAULT_BRAND: MantineColorsTuple = [
  "#e7f5ff",
  "#d0ebff",
  "#a5d8ff",
  "#74c0fc",
  "#4dabf7",
  "#339af0",
  "#228be6",
  "#1c7ed6",
  "#1971c2",
  "#1864ab",
];

export function buildTheme(_brandColor?: string) {
  return createTheme({
    primaryColor: "brand",
    colors: {
      brand: DEFAULT_BRAND,
    },
    fontFamily: "Inter, system-ui, sans-serif",
    defaultRadius: "md",
    components: {
      Button: {
        defaultProps: { radius: "md" },
      },
      // Mantine Badge etiketi varsayılan olarak `text-overflow: ellipsis` +
      // sabit max-width ile kırpar; dar tablo hücreleri / drawer'larda
      // "Aktif" → "A...", "QR" → "Q..." gibi anlamsız kesilmelere yol açar.
      // Uygulama genelinde badge'ler kısa metinlerdir → kırpmayı kapatıp tam
      // metni gösteriyoruz (gerekirse hücre/tablo yatay kayar).
      Badge: {
        styles: {
          root: { maxWidth: "unset" },
          label: { overflow: "visible" },
        },
      },
    },
  });
}

export const theme = buildTheme();
